import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import Header from "../../components/Header";
import PieCharts from "../../components/PieCharts";
import { mockDataProjects as projectData } from "../../data/mockProjectData";

const Pie = () => {

    const bdOwners=[]
    projectData.forEach((item)=>{
        if (!bdOwners.includes(item.bd_owner)){
            bdOwners.push(item.bd_owner);
        }
    })

    const [Filters, setFilters] = useState('');
    const handleChange = (event) => {
        setFilters(event.target.value);
    };


    return (
        <Box m="20px">
            <Box
                width="100%"
                display="flex"
                flexDirection="row"
                alignItems="flex-start"
                justifyContent="space-between"
            >
                <Header title="Pie Charts" subtitle="Pie Representation of the company data" />
                <FormControl  sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-helper-label">Filters</InputLabel>
                    <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={Filters}
                        label="Filters"
                        onChange={handleChange}
                  
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {bdOwners.map((item,key)=>{
                            return(
                                <MenuItem key={key} value={item}>{item}</MenuItem>
                            )
                        })}
                     
                    </Select>
                    <FormHelperText>Select BD Owner to filter</FormHelperText>
                </FormControl>

            </Box>
            <Box height="75vh">
                <PieCharts  bd_owner={Filters}/>
            </Box>
        </Box>
    );
};

export default Pie;